import { render, staticRenderFns } from "./CanPayLoader.vue?vue&type=template&id=45f90e10&scoped=true&"
import script from "./CanPayLoader.vue?vue&type=script&lang=js&"
export * from "./CanPayLoader.vue?vue&type=script&lang=js&"
import style0 from "./CanPayLoader.vue?vue&type=style&index=0&id=45f90e10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f90e10",
  null
  
)

export default component.exports